export default __webpack_public_path__ + "static/media/icon-plate.0159d255.svg";